module.exports = __webpack_public_path__ + "fonts/latoblack.e631d273.ttf";